export default __webpack_public_path__ + "static/media/beeloade.51820bcd.gif";